import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c7d8fdc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4c7d8fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d8fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7d8fdc')) {
      api.createRecord('4c7d8fdc', component.options)
    } else {
      api.reload('4c7d8fdc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c7d8fdc&scoped=true&", function () {
      api.rerender('4c7d8fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/department/compoments/ECircularCategories/index.vue"
export default component.exports